var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88892 5.05556H14.1111M13.3472 5.05556L12.685 14.3307C12.6575 14.7161 12.485 15.0769 12.2023 15.3402C11.9195 15.6036 11.5474 15.75 11.161 15.75H4.83905C4.45263 15.75 4.08056 15.6036 3.79779 15.3402C3.51501 15.0769 3.34253 14.7161 3.3151 14.3307L2.6528 5.05556H13.3472ZM6.47225 8.11111V12.6944V8.11111ZM9.5278 8.11111V12.6944V8.11111ZM10.2917 5.05556V2.76389C10.2917 2.56129 10.2112 2.36699 10.068 2.22374C9.9247 2.08048 9.7304 2 9.5278 2H6.47225C6.26965 2 6.07536 2.08048 5.9321 2.22374C5.78884 2.36699 5.70836 2.56129 5.70836 2.76389V5.05556H10.2917Z",
    stroke: "#FF0000",
    strokeOpacity: 0.66,
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e5f1e77df036d912f647010633eda949.svg";
export { ForwardRef as ReactComponent };